import { render, staticRenderFns } from "./EditClientInfoDialog.vue?vue&type=template&id=37962e3a&scoped=true&"
import script from "./EditClientInfoDialog.vue?vue&type=script&lang=js&"
export * from "./EditClientInfoDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditClientInfoDialog.vue?vue&type=style&index=0&id=37962e3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37962e3a",
  null
  
)

/* custom blocks */
import block0 from "./EditClientInfoDialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports